import { useRef, useMemo } from 'react';
import classes from 'features/realplays/Components/ReportResult/ReportResult.module.css';
import PublicRealPlayHelper from 'features/publicRoleplay/publicRealPlay.helper';
import { InputSelect } from 'shared_ui_components';
import ScenarioContext from 'features/realplays/Components/ReportResult/ScenarioContext';
import RoleplayRecording from 'features/realplays/Components/ReportResult/RoleplayRecording';
import Strengths from 'features/realplays/Components/ReportResult/Strengths';
import Improvements from 'features/realplays/Components/ReportResult/Improvements';
import Feedback from 'features/realplays/Components/ReportResult/Feedback';
import Ratings from 'features/realplays/Components/ReportResult/Ratings';
import PublicTranscription from '../Common/PublicTranscription';
import SkillRatings from 'features/realplays/Components/ReportResult/SkillRatings';
import ModeLabel from 'features/realplays/Components/Common/ModeLabel';

const ViewResults = () => {
  const playerRef = useRef(null);
  const {
    videoURL,
    globalRatingCriteria,
    assignment_uuid,
    assigned_by_user,
    scenarios,
    scenariosLength,
    AIprospect,
    role,
    industry,
    situation,
    endDate,
    title,
    selectedScenario,
    rating_criteria,
    feedback,
    summary,
    setScenarioWithSelector,
  } = PublicRealPlayHelper();

  const handleSeek = (timestamp) => {
    const seconds = parseFloat(timestamp);
    const player = playerRef.current;
    if (player) {
      player.seekTo(seconds, 'seconds');
      player.getInternalPlayer()?.play?.();
    }
  };

  const options = useMemo(() => {
    if (!scenarios || scenarios?.length === 0) return [];
    return scenarios?.map((sc, i) => ({
      label: `${i + 1}. ${sc?.name}`,
      value: sc?.uuid,
    }));
  }, [scenarios]);

  const value = useMemo(() => {
    return (options ?? []).find((opt) => opt?.value === selectedScenario?.uuid);
  }, [options, selectedScenario]);

  const onSelectedValue = (value) => {
    const newList = {
      ...(scenarios ?? []).find((sce) => sce?.uuid === value),
      isRecording: false,
      tempVideoUrl: '',
    };
    setScenarioWithSelector(newList || {});
  };

  const formattedDate = () => {
    if (endDate) {
      const date = new Date(endDate);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
    return formatDate();
  };

  //const userName = User.getUserName(assigned_by_user);

  const generateRoleplayHeader = (roleplay) => {
    const userNameHeader = 'Alex Morgan';
    const dateString = formattedDate();
    const readableDate = endDate ? new Date(endDate).toDateString().substring(3) : dateString;

    if (roleplay?.toLowerCase?.() === 'objection handling') {
      return `${userNameHeader} - Handling ${selectedScenario.name} Objection with ${AIprospect.name}, ${role} on ${readableDate}`;
    }

    return `${userNameHeader} - Interactive Roleplay "${roleplay}" ${dateString}`;
  };

  return (
    <div style={{ background: '#f3f5f8', height: '100%' }}>
      <div className={classes.headerContainer}>
        <div>
          <div>
            <div className={classes.header} style={{ marginLeft: '2.5rem' }}>
              <span className="heading4">{generateRoleplayHeader(title)}</span>
            </div>
            {scenariosLength > 1 && (
              <div className={classes.scenarioSelector}>
                <InputSelect
                  value={value}
                  onChange={(opt) => onSelectedValue(opt?.value || '')}
                  options={options}
                  closeMenuOnSelect
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={classes.contextInfoContainer}>
        <ModeLabel mode="Assesment" />
      </div>
      <div className={classes.gridContainer} style={{ marginTop: 16 }}>
        <div className={classes.left}>
          <ScenarioContext
            className={classes.scenarioContainer}
            prospectName={AIprospect?.name}
            customer_role={role}
            customer_industry={industry}
            customer_situation={situation}
            selectedScenario={selectedScenario}
            scenarios={scenarios}
            title={title}
            date={formattedDate()}
          />
          <RoleplayRecording
            className={classes.recordingContainer}
            videoURL={videoURL}
            playerRef={playerRef}
          />
          {rating_criteria?.length === 0 ? (
            <Ratings
              rating_criteria={rating_criteria}
              stillInProgress
              globalRatingCriteria={globalRatingCriteria}
            />
          ) : (
            <SkillRatings rating_criteria={rating_criteria} onlyRead />
          )}
        </div>
        <div className={classes.right}>
          {feedback === '' ? (
            <Feedback
              title="Read this as your coaching summary"
              feedback={feedback}
              stillInProgress
            />
          ) : (
            <Feedback title="Read this as your coaching summary" feedback={feedback} readOnly />
          )}
          <Strengths
            title="What to double down on"
            summary={summary}
            handleSeek={handleSeek}
          />
          <Improvements title="What to fix next" summary={summary} />
        </div>
      </div>
      <div className={classes.transcriptionContainer}>
        <PublicTranscription
          assignment_uuid={assignment_uuid}
          scenario_uuid={selectedScenario?.uuid}
          response_uuid={selectedScenario?.response?.uuid}
          clientName={AIprospect?.name}
          assigned_by_user={assigned_by_user}
          client_profile_pic={AIprospect?.profile_pic}
        />
      </div>
    </div>
  );
};

export default ViewResults;

const formatDate = () => {
  const dateString = new Date();

  let month = dateString.getUTCMonth() + 1;
  if (month < 10) month = `0${month}`;
  let day = dateString.getUTCDate();
  if (day < 10) day = `0${day}`;
  let year = dateString.getUTCFullYear();

  const newDate = day + '-' + month + '-' + year;
  return newDate;
};
